module.exports = __webpack_public_path__ + "img/edit.1d6b4d27.svg";